export default __webpack_public_path__ + "static/media/367ee0a1d038d81ff5974882947f2d0f.jpg";